export default __webpack_public_path__ + "static/media/profile-bg.71911ea3.jpg";